<template>
  <div>
    <div class="col-md-3">
      <div class="all-categories mt-0 mb-20">
        <strong>{{ $t("rewards") }}</strong>
      </div>
    </div>
    <div class="row col-md-12">
      <div v-for="(reward, index) in rewards" :key="index" class="col-md-3">
        <transition-group name="fade-slow" mode="out-in" appear>
          <reward-tile :reward="reward" :rewards='rewards' :key="reward.id" :currency="project.currency" :buttonColor="crowdOrRais()" :showButtons="!project.submitted"></reward-tile>
        </transition-group>
      </div>
      <reward-form v-if="showRewardForm" :close="closeRewardForm" :rewards="rewards" :currency='project.currency' :action="'create'" :buttonColor="crowdOrRais()"></reward-form>
      <!-- Button trigger modal -->
      <div class="col-md-3" v-if="!project.isSubmitted">
        <button type="button" @click="showRewardForm = true" :class="'btn btn-tile ' + crowdOrRais()">{{ $t("reward.new") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import rewardsApi from '@/api/v1/rewards';

import RewardTile from '@/components/Reward/Tile';
import RewardForm from '@/components/Reward/Form';

import FormError from '@/components/FormError';
import Alert from '@/components/Alert';

export default {
  components: { FormError, RewardTile, RewardForm, Alert },
  props: ['project'],
  data() {
    return {
      rewards: [],
      showRewardForm: false,
      showDeleteModal: false,
    };
  },
  methods: {
    closeRewardForm() {
      this.showRewardForm = false;
    },
    crowdOrRais() {
      return this.project.crowdfunding ? 'crowd' : 'rais';
    },
  },
  created() {
    if (this.$route.params.id) {
      rewardsApi.getRewards(this.$route.params.id, (rewards) => { this.rewards = rewards; });
    }
  },
};
</script>



// WEBPACK FOOTER //
// Rewards.vue?a1fb54d4